import React from 'react';

import * as FlipdishApi from '@flipdish/api-client-typescript';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { getTranslate } from 'react-localize-redux';
import { useSelector } from 'react-redux';

import Select from '@fd/ui/Select/Select';

import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';
import { OptionType } from '../../ui/Select/Select';
import { getAllPropertiesOptionItem } from './constants';

const StyledSelect = styled(Select)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
}));

interface ModifyPermissionPropertySelectProps {
  dataFd: string;
  disabled?: boolean;
  handlePropertiesChange: (permissionLevel: FlipdishApi.TeammateBase.AppAccessLevelEnum) => any;
  isLoading?: boolean;
  isNewUser?: boolean;
  permissionLevel: FlipdishApi.TeammateBase.AppAccessLevelEnum;
  propertiesOptions?: OptionType[] | null;
  selectedProperties?: OptionType[] | null;
}

const ModifyPermissionPropertySelect: React.FC<ModifyPermissionPropertySelectProps> = (props) => {
  const translate = useSelector((state: AppState) => getTranslate(state.locale));

  const {
    dataFd,
    disabled,
    isLoading,
    isNewUser,
    handlePropertiesChange,
    permissionLevel,
    propertiesOptions,
    selectedProperties,
  } = props;

  const optionsWithAllProperties = [
    getAllPropertiesOptionItem(translate('All_Properties') as string),
    ...(propertiesOptions || []),
  ];

  return (
    <ErrorBoundary identifier="modify-permission-level-select">
      <Box>
        <StyledSelect
          isDisabled={disabled}
          dataFd={dataFd}
          isClearable
          isMulti
          maxChips={3}
          onChange={disabled ? undefined : handlePropertiesChange(permissionLevel)}
          options={optionsWithAllProperties}
          value={selectedProperties}
          placeholder={
            isNewUser ? (translate('Select_properties') as string) : (translate('None') as string)
          }
          TextFieldProps={{
            fdKey: 'properties-dropdown',
            label: translate('Properties') as TranslationId,
            name: 'properties-select',
          }}
          variant="standard"
          isLoading={isLoading}
        />
      </Box>
    </ErrorBoundary>
  );
};

export default ModifyPermissionPropertySelect;
